import { Color, ColorsPallete } from "ui/primitives";

export * from "./streaks";

export enum TypeOfTags {
  Primary,
  Secondary,
}

export enum TypeOfOptions {
  Image = "image",
  Text = "text",
}

export enum TypeOfReward {
  Gift = 1,
  Promocode = 2,
}

export const isCheckoutPopupShown = "isCheckOutPopupShown";

export enum RewardStatus {
  Pending = "Pending",
  Issued = "Issued",
  Success = "Success",
  Empty = "",
  Streaks = "Streaks",
}

export enum ContentType {
  Post = 0,
  QnA = 1,
  Poll = 2,
  PostWithoutModeration = 3,
  Ads = 4,
}

export enum ScPageSource {
  Shared = "shared",
  Notification = "notification",
  Origin = "origin",
  PollOfTheDay = "poll-of-the-day",
}

export const QuickMsgs = [
  "🔥",
  "😈😈",
  "😍",
  "👍",
  "👏",
  "Mind blowing😱",
  "Nice!",
];

export const userProfile = "socialCommunityUserProfile";

export const isNumberNudgeShown = "isNumberNudgeShown";

export const numberOfRewards = 2;

export const streakBreakPopupShown = "streakBreakPopupShown";

export const isStreakExtraRewardPopupShown = "isStreakExtraRewardPopupShown";

export const isStreakNewRulesShown = "isStreakNewRulesShown";

export const REMOVED_SC_BANNER = "REMOVED_SC_BANNER";

export const isCommunitySsrDataStoredInRedux =
  "isCommunitySsrDataStoredInRedux";

export const customInputStyle = {
  border: "1px solid transparent",
  fontFamily: "RobotoMedium",
  fontSize: "20px",
  color: "#00163E",
  marginRight: "18px",
  marginLeft: "18px",
};

export const routes = {
  home: "/social-community",
  challenges: "/social-community/challenges",
  createPost: "/social-community/create-post",
  landingPage: "/social-community/landing-page",
  moderation: "/social-community/moderation",
  posts: "/social-community/posts",
  profile: "/social-community/profile",
  editProfile: "/social-community/profile/edit",
  saved: "/social-community/saved",
  interests: "/social-community/interests",
  guidelines: "/social-community/guidelines",
  store: "https://parkplus.io/app/services/parkplus-store",
  storeCart: "https://parkplus.io/app/services/parkplus-store/fill-cart",
  adminProfile: "/social-community/admin-profile",
  botProfile: "/social-community/bot-profile",
  streaks: "/social-community/streaks",
  quiz: "/social-community/streaks/quiz",
  challengeMilstones: "/social-community/streaks/challenges/milestones",
  challengeRewards: "/social-community/streaks/challenges/rewards",
  taggedProfile: "/app/content/social-community/profile",
  notifications: "/social-community/notification",
  commentListForNative: "/app/content/social-community/comment-list-native",
};

export enum InteractionType {
  Like = 0,
  Share = 1,
  Vote = 2,
  Answer = 3,
  Comment = 4,
  Reply = 5,
  ModeerationReviewByUser = 6,
  Unlike = 7,
  Report = 8,
  Bookmark = 9,
  Unbookmark = 10,
  Follow = 11,
  LikeOnComment = 12,
  UnLikeOnComment = 13,
  PinPost = 14,
  UnPinPost = 15,
}

export enum MultipleEmojiTypes {
  Default = 0,
  Like = 1,
  Shock = 2,
  Laugh = 3,
  Target = 4,
  Cool = 5,
  Celebrate = 6,
}

export const MultipleEmojiUrls = {
  [MultipleEmojiTypes.Like]: {
    img: "https://parkplus-bkt-img.parkplus.io/production/social-community/public/communityLike_20230918153632076199.png",
    text: "Liked",
  },
  [MultipleEmojiTypes.Shock]: {
    img: "https://parkplus-bkt-img.parkplus.io/production/social-community/public/communityShock_20230918153609645197.png",
    text: "Amazing",
  },
  [MultipleEmojiTypes.Laugh]: {
    img: "https://parkplus-bkt-img.parkplus.io/production/social-community/public/communityFunny_20230918153436829404.png",
    text: "Funny",
  },
  [MultipleEmojiTypes.Target]: {
    img: "https://parkplus-bkt-img.parkplus.io/production/social-community/public/communityTarget_20230918153503540427.png",
    text: "On-point",
  },
  [MultipleEmojiTypes.Cool]: {
    img: "https://parkplus-bkt-img.parkplus.io/production/social-community/public/communityCool_20230918153542129668.png",
    text: "Smart",
  },
  [MultipleEmojiTypes.Celebrate]: {
    img: "https://parkplus-bkt-img.parkplus.io/production/social-community/public/communityCelebrate_20230918153408733027.png",
    text: "Congrats",
  },
};

export const FirstEmojiReactionLocalStorageKey =
  "FirstEmojiReactionLocalStorageKey";

export enum UserInteractionType {
  LikeEvent = 1,
  CommentEvent = 2,
  ShareEvent = 3,
  VoteEvent = 4,
  AcknowledgeEvent = 5,
  ReportEvent = 6,
  BookmarkEvent = 7,
  UnlikeEvent = 8,
  UnBookmarkEvent = 9,
  PinEvent = 10,
  UnpinEvent = 11,
}

export enum EntityType {
  PostEntity = 1,
  QnaEntity = 2,
  PollEntity = 3,
  CommentEntity = 4,
  ReplyEntity = 5,
  NoModPostEntity = 6,
}

export enum MediaTypes {
  images = "Images",
  videos = "Videos",
}

export enum ReviewStatus {
  Pending = 0,
  Approved = 1,
  Rejected = 2,
  Reported = 3,
}

export enum RewardsChallengeType {
  FuelRewards = "1",
}

export enum FeedComponents {
  ParkplusStoreAds = "parkplus_store_ads",
  PollOfTheDayContent = "poll_of_the_day_content",
  SCPost = "social_community_content",
  TrendingPost = "trending_social_community_content",
  Discover = "discover",
  Banner = "banner",
  UserInterestSelectionNudge = "user_interest_selection_nudge", // discontinue
  UserNameSelectionNudge = "user_name_selection_nudge", // discontinue
  ThemebotPosts = "themebot", // discontinue
  MultipleThemebotPosts = "themebot_mix", // discontinue
  InfluencerFollow = "follow_influencer", // discontinue
  InfluencerPost = "influencer_post", // discontinue
  ThemebotFollow = "follow_themebot",
  Ads = "store-ads", // ads
  PplPoll = "ppl_poll", // content on ppl
  PplContent = "ppl_content", // content on ppl
  Offences = "offence-report", // offence content ui same as shorts
  PplDiscoverQuizWidget = "ppl_discover_quiz", // content on ppl
  SocialMediaBanner = "social_media_banner", // discontinue
  CarReviewsPosts = "car_reviews", // same as trending
  StreakBanner = "streaks_banner", // discontinue
  FuelPageWidget = "fuel_page_ingress", // discontinue
  StreaksTrending = "trending_high", // same as trending
  CarCareTips = "car_care_tips", // same as trending
  PollutionPledge = "pollution_pledge",
  VotePledge = "vote_pledge", // same as trending
  CommunityVideos = "community_videos", // shorts
  FollowedHandlesPosts = "followed_handles_posts", // same as trending
}

export enum LayoutTypes {
  Vertical = "vertical",
  Carousel = "carousel",
}

export const contentBasePath = "https://parkplus.io/app/content";
export const mWebBasePath = "https://m.parkplus.io";

export enum EditFieldTypes {
  ProfilePicture = "profilePicture",
  Name = "name",
  Phone = "phone",
  Username = "username",
  Location = "location",
  Email = "email",
  Birthday = "birthday",
  About = "about",
}

export const defaultFeedFilters = [
  {
    icon: "",
    label: "For you",
    value: "all",
    order: 1,
    selectedIcon: "",
    showTabsAnimation: false,
    brand: "",
  },
  {
    icon: "",
    label: "Polls",
    value: "polls",
    order: 3,
    selectedIcon: "",
    showTabsAnimation: false,
    brand: "",
  },
  {
    icon: "",
    label: "Influencers",
    value: "influencer",
    order: 4,
    selectedIcon: "",
    showTabsAnimation: false,
    brand: "",
  },
  {
    icon: "",
    label: "Themes",
    value: "themebot",
    order: 5,
    selectedIcon: "",
    showTabsAnimation: false,
    brand: "",
  },
];

export enum fileType {
  Image = "Images",
  Video = "Videos",
}

export enum SimilarContentActions {
  Like = "like",
  Poll = "vote",
  Video = "video",
}

export const SharedAchivementTypes = {
  Challenge: {
    heading: "Onboarding challenge completed",
    body: "Oh yeahh! I have completed the onboarding challenge and got an Achiever badge 🎉",
    mediaImage: [
      "https://parkplus-bkt-img.parkplus.io/production/team/public/13378062-FS-fa4efdfc-b16d-4fcd-8410-8a78d14f5dea.png",
    ],
  },
  Reward: {
    heading: "Look what I won!",
    body: "Guys, I just got my hands on exciting car goodies for completing the onboarding challenge... You could win them too",
    mediaImage: [
      "https://parkplus-bkt-img.parkplus.io/production/team/public/13378271-FS-b4e9705f-7f16-410f-bc8c-f00a94e1137e.png",
    ],
  },
  Promocode: {
    heading: "Look what I won!",
    body: "Guys, I just got my hands on exciting Park+ coupons... You could win them too",
    mediaImage: [
      "https://parkplus-bkt-img.parkplus.io/production/team/public/13378345-FS-f84f5888-194d-4419-8b36-8144883856b0.png",
    ],
  },
  StreakScore: {
    heading: "Woohoo!!🤩🤘",
    body: "Winning free Petrol with Community's Daily Quiz is awesome! What are you waiting for? Play now!",
  },
};
export const profilePicColors = [
  `var(--${Color.interaction_50})`,
  `var(--${Color.emerald_60})`,
  `var(--${Color.negative_40})`,
  `var(--${Color.blue_60})`,
  `var(--${Color.orange_60})`,
  `var(--${Color.rosewood_50})`,
  `var(--${Color.positive_40})`,
];

export const StreakSharePost = [
  {
    bgColor: "linear-gradient(135deg, #FE9FBD 0%, #E01854 100%)",
    color: Color.emerald_30,
  },
  {
    bgColor: "linear-gradient(134deg, #5DBFB9 0%, #13645F 100%)",
    color: Color.interaction_30,
  },
  {
    bgColor: "linear-gradient(59deg, #0937A5 0%, #8167FF 49.5%, #7AD9D3 100%)",
    color: Color.rosewood_30,
  },
];

export const profileAvatars = [
  "https://parkplus-production-img-bkt.parkplus.io/profile/container-9.png",
  "https://parkplus-production-img-bkt.parkplus.io/profile/container-8.png",
  "https://parkplus-production-img-bkt.parkplus.io/profile/container-7.png",
  "https://parkplus-production-img-bkt.parkplus.io/profile/container-6.png",
  "https://parkplus-production-img-bkt.parkplus.io/profile/container-3.png",
  "https://parkplus-production-img-bkt.parkplus.io/profile/container-2.png",
];

export enum ActionType {
  Web = "web",
  Native = "native",
  Popup = "popup",
  ExternalUrl = "external_url",
}

export enum BannerTypes {
  Basic = "basic",
  Progressive = "progressive",
}

export enum FollowActionType {
  Followers = 0,
  Following = 1,
}

export const Emojis = [
  "/app/content/img/social-community/landing-page/emoji/1.png",
  "/app/content/img/social-community/landing-page/emoji/2.png",
  "/app/content/img/social-community/landing-page/emoji/3.png",
  "/app/content/img/social-community/landing-page/emoji/4.png",
  "/app/content/img/social-community/landing-page/emoji/5.png",
  "/app/content/img/social-community/landing-page/emoji/6.png",
  "/app/content/img/social-community/landing-page/emoji/1.png",
  "/app/content/img/social-community/landing-page/emoji/2.png",
  "/app/content/img/social-community/landing-page/emoji/3.png",
  "/app/content/img/social-community/landing-page/emoji/4.png",
  "/app/content/img/social-community/landing-page/emoji/5.png",
  "/app/content/img/social-community/landing-page/emoji/6.png",
  "/app/content/img/social-community/landing-page/emoji/1.png",
  "/app/content/img/social-community/landing-page/emoji/2.png",
  "/app/content/img/social-community/landing-page/emoji/3.png",
  "/app/content/img/social-community/landing-page/emoji/4.png",
  "/app/content/img/social-community/landing-page/emoji/5.png",
  "/app/content/img/social-community/landing-page/emoji/6.png",
];
export const ScrollImages = [
  "https://parkplus-bkt-img.parkplus.io/production/team/public/13868559-FS-6889c0f6-5b23-477e-ad11-9109f8a0e80d.png",
  "https://parkplus-bkt-img.parkplus.io/production/team/public/13868664-FS-d2697d7b-1593-4430-91a1-fc1ca01deec2.png",
  "https://parkplus-bkt-img.parkplus.io/production/team/public/13868677-FS-7f6ad289-08e6-4ed1-b5b8-324f47f2b626.png",
  "https://parkplus-bkt-img.parkplus.io/production/team/public/13868687-FS-a7191d53-7de5-4a1f-8d4f-2fbb180dd92d.png",
  "https://parkplus-bkt-img.parkplus.io/production/team/public/13868699-FS-de206c75-24d6-4bc1-8dfa-76db08e7f6c5.png",
  "https://parkplus-bkt-img.parkplus.io/production/team/public/13868714-FS-9a064d27-277f-4d6c-914f-1e7b58fca36c.png",
  "https://parkplus-bkt-img.parkplus.io/production/team/public/13868731-FS-2c7736ac-50c9-4b64-811e-742986469508.png",
  "https://parkplus-bkt-img.parkplus.io/production/team/public/13868749-FS-3fa03068-f82a-486e-b2ed-c64d5ce1361b.png",
  "https://parkplus-bkt-img.parkplus.io/production/team/public/13868771-FS-f3e19aa7-877f-4581-a1be-bcbd7b1ac787.png",
  "https://parkplus-bkt-img.parkplus.io/production/team/public/13868781-FS-eb1f5dd3-6407-419b-965a-160c064f6349.png",
  "https://parkplus-bkt-img.parkplus.io/production/team/public/13868790-FS-d1cbd5df-f7a2-4a95-8f18-5de198a507d2.png",
  "https://parkplus-bkt-img.parkplus.io/production/team/public/13868798-FS-c2ab4ed2-82ce-4599-be69-bb1f38becf7e.png",
  "https://parkplus-bkt-img.parkplus.io/production/team/public/13868807-FS-a24d5fd3-68e0-4d94-a118-e9d8fed3fc8f.png",
  "https://parkplus-bkt-img.parkplus.io/production/team/public/13868818-FS-f3f61b44-0622-4676-bb56-a8ddda1b62c2.png",
  "https://parkplus-bkt-img.parkplus.io/production/team/public/13868828-FS-a06253be-5cfd-4acf-8bb4-f340947f5d4a.png",
  "https://parkplus-bkt-img.parkplus.io/production/team/public/13868836-FS-e9503ad5-ef2e-41ab-ab63-651776478ab4.png",
];

export const community = "community";

export const PostImages = [
  "/app/content/img/social-community/landing-page/posts/1.png",
  "/app/content/img/social-community/landing-page/posts/2.png",
  "/app/content/img/social-community/landing-page/posts/3.png",
  "/app/content/img/social-community/landing-page/posts/4.png",
  "/app/content/img/social-community/landing-page/posts/5.png",
  "/app/content/img/social-community/landing-page/posts/1.png",
  "/app/content/img/social-community/landing-page/posts/2.png",
  "/app/content/img/social-community/landing-page/posts/3.png",
  "/app/content/img/social-community/landing-page/posts/4.png",
  "/app/content/img/social-community/landing-page/posts/5.png",
];

export const BioTemplates = [
  "Incomplete since Michael Schumacher said goodbye",
  "Pick your side: Hamilton or Verstappen?",
  "One day I will drive through the Nürburgring Circuit",
  "Chronicling from Monaco to Abu Dhabi",
  "Hard to chose between Petronas and Red Bull",
  "Checo Perez for the win!",
  "I like what's under that hood",
  "Nothing excites me more than a powerful engine",
  "Hood ke neeche kya hai?",
  "Trying to learn more about the cars and what goes on inside them",
  "The engine says it all",
  "Anyone can buy a car, a true enthusiast knows it inside and out",
  "Your car's paint job caught my eye",
  "My car is as flashy as my personality",
  "P1 cleaner than your dress shoes",
  "Looking good while driving round town, that's my motto",
  "Want the cars that rappers brag about",
  "Behind the right set of wheels, the world feels a lot shinier",
  "The road is my home",
  "Finding new roads, one mile at a time",
  "You won't find me in one fixed place",
  "Never too soon to plan your next road trip",
  "Four wheels and an open road, how I wish to live my life.",
  "Choosing the scenic route because I prefer to travel than arrive.",
];

export const INTEREST_NUDGE_TAGS = [
  {
    name: "road trip",
    uuid: "49fa5a4b-8066-425b-be5b-a05df72cefd3",
    id: 0,
    tagType: TypeOfTags.Primary,
    isActive: true,
    secondaryTags: [],
    parentId: null,
    icon: "https://parkplus-bkt-img.parkplus.io/production/social-community/public/17644252-road_trips-652d5e85-895a-460f-9f61-9a577783b8c9.png",
  },
  {
    id: 0,
    uuid: "33d3aa8f-db4e-4e1d-9f95-7cbf070d84ed",
    name: "traffic",
    tagType: TypeOfTags.Primary,
    isActive: true,
    secondaryTags: [],
    parentId: null,
    icon: "https://parkplus-bkt-img.parkplus.io/production/social-community/public/17644192-Traffic-2adaef08-e703-4a9a-8f64-4047da32b0a8.png",
  },
  {
    name: "car policies",
    uuid: "037f8657-d1a9-4592-b872-e37822907175",
    id: 0,
    tagType: TypeOfTags.Primary,
    isActive: true,
    secondaryTags: [],
    parentId: null,
    icon: "https://parkplus-bkt-img.parkplus.io/production/social-community/public/17644344-car_policies-bef3219c-9acc-47d8-891c-fd0353b29874.png",
  },
  {
    id: 0,
    uuid: "61a7c1d7-b2f9-4a2c-a42f-0b07190c8c86",
    name: "electric vehicle",
    tagType: TypeOfTags.Primary,
    isActive: true,
    secondaryTags: [],
    parentId: null,
    icon: "https://parkplus-bkt-img.parkplus.io/production/social-community/public/17644075-Electric_vehicle-2179180b-af0a-4065-bbe6-a9f26ebaaa6d.png",
  },
  {
    id: 0,
    uuid: "b1539d62-81e9-4759-95f2-d129268f7c31",
    name: "vintage",
    tagType: TypeOfTags.Primary,
    isActive: true,
    secondaryTags: [],
    parentId: null,
    icon: "https://parkplus-bkt-img.parkplus.io/production/social-community/public/17644284-Vintage_cars-d359c877-bfb0-4256-a6d5-c000cf823a75.png",
  },

  {
    id: 0,
    uuid: "608023b4-ff89-466e-b098-797b5f1ff2b4",
    name: "car price",
    tagType: TypeOfTags.Primary,
    isActive: true,
    secondaryTags: [],
    parentId: null,
    icon: "https://parkplus-bkt-img.parkplus.io/production/social-community/public/17644470-car_price-974f6d4c-73bb-4815-8b0f-0e191d22bee2.png",
  },
  {
    id: 0,
    uuid: "a35ef0c7-d2c6-49b8-8ada-c052fad03a33",
    name: "features",
    tagType: TypeOfTags.Primary,
    isActive: true,
    secondaryTags: [],
    parentId: null,
    icon: "https://parkplus-bkt-img.parkplus.io/production/social-community/public/17644448-Features-62d87fdf-ceb7-4386-84c1-f5628d5422c4.png",
  },
  {
    id: 0,
    uuid: "de37da1c-1980-49ea-ab45-c54dbbdda48a",
    name: "hacks for car",
    tagType: TypeOfTags.Primary,
    isActive: true,
    secondaryTags: [],
    parentId: null,
    icon: "https://parkplus-bkt-img.parkplus.io/production/social-community/public/17644228-hacks_for_cars-f33d0ff0-428d-49ec-af74-922ea213df1d.png",
  },
  {
    id: 0,
    uuid: "91c80f18-5237-42f5-bca4-a481050edd65",
    name: "cars 2022",
    tagType: TypeOfTags.Primary,
    isActive: true,
    secondaryTags: [],
    parentId: null,
    icon: "https://parkplus-bkt-img.parkplus.io/production/social-community/public/17644318-Cars_2022-cb8025d4-9d6f-4f6c-adb7-0d983fe34df3.png",
  },
];

export enum RecommendedPostTypes {
  contentBasedPosts = "contentBasedPosts",
  userBasedPosts = "userBasedPosts",
}

export enum FLIP_TYPE {
  description = "description",
  def = "def",
  option = "option",
}

export enum Products {
  Carwash = "carwash",
  Store = "store",
}

export enum PageIntents {
  ConfirmationScreen = "confirmation_screen",
}

export enum BackActions {
  Close = "close",
}

export const COMPONENT_TYPE = {
  insights: "insights",
  video: "playlist",
  reviews: "user_review",
  userReviews: "user_review",
  knowledgeCenter: "knowledge_center",
  aboutComponents: "about_components",
  addOns: "add_ons",
  news: "news_feed",
};

export enum CONTENT_SOURCE {
  Landing = "landing",
  Bookmarks = "bookmarks",
  Share = "share",
  Insights = "insights",
  Search = "search",
  ViewAll = "view_all",
}

export enum ShortsSources {
  Discover = "discovery",
  Community = "community",
  Offence = "offence",
}

export const QuizSummaryRemarks = {
  zero: {
    title: "Uh-oh!",
    subTitle: "Don't worry, keep at it & you will become a car master soon!",
  },
  belowAvg: {
    title: "Doing great!",
    subTitle: "Keep at it & you will become a car master soon!",
  },
  aboveAvg: {
    title: "Awesome champ!",
    subTitle: "You are a car wizard! Keep at it & you will become a master!",
  },
  best: {
    title: "Beyond Amazing!",
    subTitle: "You are the master of the car universe!",
  },
};

export const STREAKS_CORRECT_ANS_AUDIO_ID = "ScStreaksCorrectAnsAudio";
export const STREAKS_BG_AUDIO_ID = "ScStreaksBGAudio";

export enum RepairPopupStep {
  MainPopup = 0,
  ContinuePopup = 1,
  LoseStreakPopup = 2,
  LowMlPopup = 3,
  StreakNotRepairPopup = 4,
}

export enum streakAction {
  Repair = "repair",
  SkipRepair = "skip-repair",
}

export const faq = [
  {
    title: "What are Daily quiz streaks?",
    description:
      "Daily quiz is your play-to-win arena where you can earn free petrol by playing a quiz daily and answering questions correctly. A collection of 5 questions will be presented which upon completion will earn you a streak day. The more days in a row you play the quiz, the more petrol you can earn for free.",
  },
  {
    title: "How to play and win free petrol?",
    description:
      "To earn free petrol, all you need to do is play the Daily Quiz and answer questions correctly every day. Each day that you play consecutively, you will earn more petrol for free. You can earn up to 5 litres of petrol for free in a month just by playing the quiz every day. Also, bragging rights on the leaderboard for the longest possible streak which you can share with your friends.",
  },
  {
    title: "Do I need to answer the questions correctly to earn free petrol?",
    description:
      "Yes, each correct question will earn you free petrol. In spirit of the competition, we have made this change to reward our patrons. Unfortunately, you will not earn free petrol for the day if you answer all questions incorrectly. However, do not worry, your streak day will still be counted if you've attempted the quiz for the day.",
  },
  {
    title: "How can you redeem your earned rewards?",
    description:
      "You can check your progress with Park+ Petrol. Once you've collected a total of 5 Litres of petrol, you can redeem your petrol. For more details, refer to the Park+ petrol terms and conditions on their page.",
  },
  {
    title: "What happens if I lose my daily quiz streak?",
    description:
      "Your earned rewards will stay with you, however, your streak days will reset to Day 1. Don't worry, you can quickly build up the same again and guess what, you will still win free petrol for playing everyday.",
  },
];
export const translatePosition = [
  -70, -55, -43, -36, -36, -45, -60, -74, -84, -85, -78, -65, -50, -40, -35,
  -37, -47, -62, -76, -85, -85, -75, -62, -48, -38, -34, -38, -50, -63, -77,
];

export const getTextDaysColor = {
  1: "emerald_secondary",
  2: "orange_secondary",
  3: "rosewood_secondary",
};
